module.exports = __webpack_public_path__ + "img/safe02.991c3069.png";